// Mark Tiptap para [[wiki-link]]. Detecta padrão no input rule e cria mark
// "wikiLink" com atributo `target` (texto do match).
// Resolução de target -> documentId fica para um pós-processador (queries.ts).

import { Mark, mergeAttributes } from '@tiptap/core';

export interface WikiLinkOptions {
  HTMLAttributes: Record<string, unknown>;
  onResolve?: (target: string) => string | null;
}

export const WikiLink = Mark.create<WikiLinkOptions>({
  name: 'wikiLink',

  addOptions() {
    return {
      HTMLAttributes: { class: 'wiki-link' },
    };
  },

  addAttributes() {
    return {
      target: {
        default: null,
        parseHTML: (el) => (el as HTMLElement).getAttribute('data-target'),
        renderHTML: (attrs) => ({ 'data-target': attrs.target as string }),
      },
      documentId: {
        default: null,
        parseHTML: (el) => (el as HTMLElement).getAttribute('data-document-id'),
        renderHTML: (attrs) =>
          attrs.documentId ? { 'data-document-id': attrs.documentId as string } : {},
      },
    };
  },

  parseHTML() {
    return [{ tag: 'a.wiki-link' }];
  },

  renderHTML({ HTMLAttributes }) {
    return ['a', mergeAttributes(this.options.HTMLAttributes, HTMLAttributes), 0];
  },

  // Input rule: ao digitar `]]` depois de `[[texto]]`, aplica mark.
  addInputRules() {
    return [
      {
        find: /\[\[([^\]]+)\]\]$/,
        handler: ({ range, match, commands }) => {
          const target = match[1]?.trim();
          if (!target) return null;
          commands.deleteRange(range);
          commands.insertContent({
            type: 'text',
            text: target,
            marks: [{ type: 'wikiLink', attrs: { target } }],
          });
          return null;
        },
      },
    ];
  },
});
